import { render, staticRenderFns } from "./FileUploadField.vue?vue&type=template&id=508f8b20&scoped=true"
import script from "./FileUploadField.vue?vue&type=script&lang=js"
export * from "./FileUploadField.vue?vue&type=script&lang=js"
import style0 from "./FileUploadField.vue?vue&type=style&index=0&id=508f8b20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f8b20",
  null
  
)

export default component.exports